import Joi from 'joi';
import imagesWithBlurSchema from '@utils/validate/blocksSchemes/imagesWithBlurSchema';
const featuresBlockSchema = Joi.object({
  type: Joi.string().valid('featuresBlock').required(),
  code: Joi.string().allow('', null).required(),
  header: Joi.string().allow('', null).required(),
  blocks: Joi.array().items(Joi.object({
    itemId: Joi.string().required(),
    title: Joi.string().allow('', null),
    description: Joi.string().allow('', null).required(),
    blockImage: imagesWithBlurSchema.allow('', null).required(),
    blockVideo: Joi.string().allow('', null).required(),
    buttonText: Joi.string().allow('', null),
    buttonURL: Joi.string().allow('', null)
  })).required(),
  voxboxButton: Joi.boolean().allow(null).required()
}).unknown(true);
export default featuresBlockSchema;